module.exports = __webpack_public_path__ + "static/media/radiation_safety_plan_review_documents.06a6cd32.svg";